import ProjectBrowseProjectComponent from './project-browse-project.component'

const ProjectBrowseProjectModule = angular.module('cdbl.project-browse-project', [

])
  .component('cdblProjectBrowseProject', ProjectBrowseProjectComponent)
  .name

export default ProjectBrowseProjectModule
